export const AsyncPaymentCanceledResponseStatus = 499
export const AsyncPaymentRedirectToPspResponseStatus = 303

export const AsyncPaymentPendingStatus = [
  '300', // The AsyncPaymentRedirectionData is still not received from the PSP
  '301', // The AsyncPaymentRedirectionData has just been received from the PSP and the finalization
]
